import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "../dashboard/navigation.jsx";
import Modal from "../widgets/modal";
import CreateNewOrder from "./components/create-new-order";

import { OrdersProvider } from "./orders/orders.context.jsx";
import OrdersList from "./orders/OrdersList.jsx";
import OrderStateFilter from "./orders/OrderStateFilter.jsx";
import OrderSearchFilter from "./orders/OrderSearchFilter.jsx";
import OrderMyStateFilter from "./orders/OrderMyStateFilter.jsx";
import OrderStatusFilter from "./orders/OrderStatusFilter.jsx";

export default function Orders() {
  const location = useLocation();

  let [openCreateNewOrderModal, setOpenCreateNewOrder] = useState(false);

  return (
    <OrdersProvider>
      <div className="page-content body-white orders">
        <div className="grid-container">
          <Navigation
            navigator={
              location?.state?.searchValue
                ? [
                    {
                      label: location?.state?.funeralHomeName,
                      path: `/funeral-home/${location?.state?.funeralHomeId}`,
                    },
                  ]
                : []
            }
            heading="Customer Orders"
          />
          <button onClick={() => setOpenCreateNewOrder(true)} className="button btn-create-product">
            + Create a new Order
          </button>
          <div className="small-12">
            <div className="orders-filter-container">
              <div className="orders-filter-col-1 ">
                <OrderStatusFilter />
              </div>

              <div className="orders-filter-col-2 ">
                <div className=" ">
                  <OrderSearchFilter />
                  <OrderStateFilter />
                  {/* <OrderMyStateFilter /> */}
                </div>
              </div>
            </div>
          </div>
          <OrdersList />
        </div>

        <Modal open={openCreateNewOrderModal} classes="modal-confirm-fast-track" width="460">
          <button onClick={() => setOpenCreateNewOrder(false)} className="btn-close">
            <i className="far fa-times"></i>
          </button>
          <CreateNewOrder cancel={() => setOpenCreateNewOrder(false)} />
        </Modal>
      </div>
    </OrdersProvider>
  );
}
